import http from '../../http';

import appConfig from '../../services/AppConfigService';


export default {

  callBusinessRule: function(params, payload, businessRuleId) {

    let url = this.resolveFormDesc(params) + "/businessRule/" + businessRuleId;

    let dataToSend = {
      data: payload
    };

    return http({
      method: 'post',
      url: url,
      data: JSON.stringify(dataToSend)
    }).then(response => {

      if (response.data.meta.code === 200) {
        response.data.body.instance["_updated"] = new Date();
      }

      return response.data
    })
  },

  resolveFormUri: function(params) {

    let businessAreaId = params.businessAreaId;
    let systemId = params.systemId;
    let systemVersion = params.systemVersion;
    let formId = params.formId;

    return "/f/ba" + "/" + businessAreaId + "/c/" + systemId + "/" + systemVersion + "/ms/" + formId;
  },

  resolveFormDesc: function(params) {
    return appConfig.apiUrl() + this.resolveFormUri(params);
  },

  resolveUrlWithOutFilter: function(params) {

    let url = this.resolveFormDesc(params);

    return (url + "/rows");
  },

  resolveFormDataRows: function(params, filter) {

    let url = this.resolveUrlWithOutFilter(params);

    if (filter) {

      let query = [];

      _.forOwn(filter, function (value, key) {
        if (value) {
          query.push(key + "=" + value);
        }
      });

      if (query.length > 0) {
        url = url + "?" + query.join("&");
      }
    }

    return http.get(url)
      .then(response => {
        return response.data.data
      })
  },

  resolveFormDataRow: function(params, id) {
    return this.resolveFormDataRow(params, id, null);
  },

  resolveFormDataRow: function(params, id, resourceType) {

    let url = this.resolveFormDesc(params);
    url = url + "/rows/" + id;

    if (resourceType) {
      url = url + "/" + resourceType;
    }

    return http.get(url).then(response => {
      return response
    });
  },

  moduleFormRowSave: function (params, id, payload) {

    let url = this.resolveFormDesc(params);

    url += "/rows";

    if (id) {
      url += "/" + id;
    }

    let dataToSend = {
      data: payload
    };

    return http({
      method: id ? 'put' : 'post',
      url: url,
      data: JSON.stringify(dataToSend)
    }).then(response => {
      return response.data
    })
  },

  generatePDF: function(params, payload, businessRuleId) {

    let url = this.resolveFormDesc(params) + "/exportPDF/" + businessRuleId;

    let dataToSend = {
      data: payload
    };

    return http({
      method: 'post',
      url: url,
      data: JSON.stringify(dataToSend),
      responseType: 'arraybuffer'
    })
  },

  moduleFormGenerateReport: function (params, payload) {
    this.moduleFormGenerateReport(params, payload, false);
  },

  moduleFormGenerateReport: function (params, payload, report2) {

    let url = this.resolveFormDesc(params);

    if (report2) {
      url += "/report2";
    } else {
      url += "/report";
    }

    let dataToSend = {
      data: payload
    };

    return http({
      method: 'post',
      url: url,
      data: JSON.stringify(dataToSend),
      responseType: 'arraybuffer'
    }).then(response => {

      if (response.headers["content-type"] == "application/octet-stream") {

        // open tab
        /*let blob = new Blob([response.data], { type: 'application/pdf' } );
        url = window.URL.createObjectURL(blob);
        window.open(url);*/

        // download
        let blob = new Blob([response.data], { type: 'application/pdf' } );

        let link = document.createElement('a');
        document.body.appendChild(link);
        let url = window.URL.createObjectURL(blob);
        link.style = "display: none";
        link.href = url;
        link.download = response.headers['x-filename'];
        link.click();
        window.URL.revokeObjectURL(url);

        return {
          meta: {
            code: 200
          }
        }

      } else {

        let binaryString = String.fromCharCode.apply(null, new Uint8Array(response.data));
        return JSON.parse(binaryString);
      }
    })
  },

  moduleFormRowDelete: function (params, id) {

    let url = this.resolveFormDesc(params);

    return http.delete(url + "/rows/" + id)
      .then(response => {
        return response.data
      })
  },

  /////////////

  resolveModuleDescription: function (params) {

    return http.get(this.resolveFormDesc(params))
      .then(response => {
        return response.data;
      })
  },

  resolveModuleFields: function (params) {

    return http.get(this.resolveFormDesc(params))
      .then(response => {
        return response.data.fields;
      })
  },

  formatDataValues: function() {
    return "Teste"
  },

  resolveSystemVersion: function(businessAreaId, systemId) {

    let url = appConfig.apiUrl() + "/f/ba" + "/" + businessAreaId + "/c/" + systemId + "/current";

    return http.get(url)
      .then(response => {
        return response.data.data
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/module/ModuleUtils.js